import { createFileRoute } from '@tanstack/react-router'

import { PageContent } from '@/components/page-content'
import { PageHeaderSkeleton } from '@/components/skeleton/page-header-skeleton'
import { TableSkeleton } from '@/components/ui/table'
import { tagsQueryOptions } from '@/modules/tag/presentation/hooks/useTags'
import { TagsPage } from '@/modules/tag/presentation/pages/TagsPage'

export const Route = createFileRoute('/_authenticated/settings/crm')({
  component: TagsPage,
  head: () => ({
    meta: [
      {
        title: 'Settings : CRM',
      },
    ],
  }),
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(tagsQueryOptions),
  pendingComponent: () => (
    <>
      <PageHeaderSkeleton cta title="Integrations" />
      <PageContent>
        <TableSkeleton />
      </PageContent>
    </>
  ),
})
